class GoogleReviewsSlider extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }

  connectedCallback() {
    this.initWhenReady();
  }

  disconnectedCallback() {
    const $ = this.getJQuery();
    const slider = this.querySelector('.google-reviews-slider__track');
    if ($ && slider && $(slider).hasClass('slick-initialized')) {
      $(slider).slick('unslick');
    }
    this.initialized = false;
  }

  getJQuery() {
    return window.theme && window.theme.jQuery ? window.theme.jQuery : null;
  }

  initWhenReady(attempts = 0) {
    if (this.initialized) return;

    const $ = this.getJQuery();
    if ($ && $.fn.slick) {
      this.initSlider($);
      return;
    }

    if (attempts < 50) {
      setTimeout(() => this.initWhenReady(attempts + 1), 100);
    }
  }

  initSlider($) {
    const sliderElm = this.querySelector('.google-reviews-slider__track');
    const wrapper = this.querySelector('.google-reviews-slider__wrap');
    const dotsContainer = this.querySelector('.google-reviews-dots');
    if (!sliderElm || !wrapper || $(sliderElm).hasClass('slick-initialized')) return;

    const prevArrow = wrapper.querySelector('.slick-prev');
    const nextArrow = wrapper.querySelector('.slick-next');
    const autoPlay = this.dataset.autoPlay !== 'false';

    $(sliderElm).slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      dots: true,
      appendDots: dotsContainer || wrapper,
      infinite: true,
      autoplay: autoPlay,
      autoplaySpeed: 6000,
      pauseOnHover: true,
      pauseOnFocus: true,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '8%'
          }
        }
      ]
    });

    this.initialized = true;
    this.classList.add('is-initialized');
  }
}

if (!customElements.get('google-reviews-slider')) {
  customElements.define('google-reviews-slider', GoogleReviewsSlider);
}
